'use strict';

module.exports = /*@ngInject*/
function() {
    return {
        link: function(scope, element, attrs) {
            angular.element(document).ready(function() {

                angular.element('.emailsignup .emailsignup-address')
                    .focus(function() {
                        this.value = '';
                        angular.element('.emailsignup .icon-email').addClass('active');
                        angular.element('.email-legal-copy').slideDown();
                    })
                    .blur(function() {
                        this.value = 'Sign up for Emails';
                        angular.element('.emailsignup .icon-email').removeClass('active');
                        angular.element('.email-legal-copy').slideUp();
                    });
            });
        }
    };
};
